module.exports = __webpack_public_path__ + "static/img/async-loading-spinner.3016b11.gif";


//////////////////
// WEBPACK FOOTER
// ./src/views/astation/img/async-loading-spinner.gif
// module id = Bu+M
// module chunks = 0